/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Leveling_DescriptionInputs */



/**
* | output |
* | --- |
* | "XP from real activity, perk roles, rank cards and /rank, free on every server. Bring your members' levels over from your old bot." |
*
* @param {Meta_Leveling_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const meta_leveling_description = /** @type {((inputs?: Meta_Leveling_DescriptionInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Leveling_DescriptionInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("XP за настоящую активность, роли-привилегии, карточки ранга и /ранг — бесплатно на любом сервере. Перенесите уровни участников из прежнего бота.")
	return /** @type {LocalizedString} */ ("XP from real activity, perk roles, rank cards and /rank, free on every server. Bring your members' levels over from your old bot.")
});